import {isTokenExpired, refreshAccessToken} from '../../app/modules/auth/redux/AuthCRUD'

import {actions} from '../../app/modules/auth/redux/AuthRedux'
import {identityLoginUrl} from '../appConfig'

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    async (config: any) => {
      let {
        auth: {accessToken},
      } = store.getState()

      config.headers.ClientId =
        process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      if (accessToken) {
        if (isTokenExpired(accessToken)) {
          const refreshResponse: any = await refreshAccessToken()
          if (refreshResponse?.accessToken) {
            accessToken = refreshResponse.accessToken

            // update redux state
            store.dispatch(actions.login(accessToken))

            // update localStorage
            localStorage.setItem('accessToken', accessToken)
          } else {
            // refresh failed
            store.dispatch(actions.logout())

            localStorage.removeItem('accessToken')

            window.location.href =
              identityLoginUrl()

            return Promise.reject('Session expired')
          }
        }

        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },

    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => response,

    (error: any) => {
      if (error.response?.status === 401) {
        store.dispatch(actions.logout())

        localStorage.removeItem('accessToken')

        window.location.href =
          identityLoginUrl()
      }

      return Promise.reject(error)
    }
  )
}

//config.headers.Authorization = accessToken
